import { useEffect } from "react";

export default function PageTitle({ title }) {
  useEffect(() => {
    document.title = title ? `HIK - ${title}` : "HIK";
  }, [title]);
  return null;
}